"use client";

import { cn } from "@/src/shared/utils/mergeTwClasses";
import { Box, IconButton } from "@mui/material";
import { FC } from "react";
import { IncrementButton } from "../lib/type";
import { WebShopIcon } from "../../WebShopIcon";

export const CounterButton: FC<IncrementButton> = ({
  currentCount,
  onIncrement,
  onDecrement,
  className,
  ...rest
}) => {
  return (
    <Box
      className={cn(
        "min-h-7 gap-2 rounded-[100px] px-1 py-[2px] flex-center-row",
        className,
      )}
      {...rest}
    >
      <IconButton
        onClick={onDecrement}
        disableRipple
        className={"h-5 w-5 rounded-full bg-white"}
      >
        <WebShopIcon name="minus" color={"#009DDE" as any} />
      </IconButton>
      <Box>{currentCount}</Box>
      <IconButton
        onClick={onIncrement}
        disableRipple
        className={"h-5 w-5 rounded-full bg-white"}
      >
        <WebShopIcon name="plus" color={"#009DDE" as any} />
      </IconButton>
    </Box>
  );
};
